import Avatar from '@components/v2/ui/Avatar/Avatar';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, useTheme } from '@mui/material';
import { useState } from 'react';
import { BrandLogos } from '../../../../services/modules/brand/brand.types';
import useWidth from '../../../Hooks/useWidth';

const DEFAULT_MAX_WIDTH = 168;
const DEFAULT_MAX_HEIGHT = 36;
const DEFAULT_MAX_HEIGHT_MOBILE = 32;

interface BrandLogoProps {
  name?: string;
  logos?: Partial<BrandLogos> & { squaredLogo?: string };
  maxWidth?: number;
  maxHeight?: number;
  showNameWithoutImage?: boolean;
}

const BrandLogo = ({
  name = '',
  logos,
  maxWidth = DEFAULT_MAX_WIDTH,
  maxHeight,
  showNameWithoutImage = false,
}: BrandLogoProps) => {
  const { palette } = useTheme();
  const { mobileWidth } = useWidth();
  const [errorUrl, setErrorUrl] = useState<string | null>(null);

  const defaultMaxHeight = mobileWidth ? DEFAULT_MAX_HEIGHT_MOBILE : DEFAULT_MAX_HEIGHT;
  const logoSize = maxHeight ?? defaultMaxHeight;
  const wideLogoUrl = palette.mode === 'dark' ? (logos?.wideOnDark ?? logos?.wide) : logos?.wide;
  const isNameVisible = !mobileWidth || (showNameWithoutImage && !logos?.squaredLogo);

  if (wideLogoUrl && errorUrl !== wideLogoUrl) {
    return (
      <img
        src={wideLogoUrl}
        alt={name}
        style={{ display: 'block', maxHeight: logoSize, width: 'auto', minWidth: 0, maxWidth }}
        onError={() => setErrorUrl(wideLogoUrl)}
      />
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        maxWidth,
        gap: 1,
      }}
    >
      <Avatar size={logoSize} src={logos?.squaredLogo} alt={name} initials={name.charAt(0)} />
      {isNameVisible && (
        <Typography variant="body2" noWrap sx={{ lineHeight: 1 }}>
          {name}
        </Typography>
      )}
    </Box>
  );
};

export default BrandLogo;
